export const metaInfo = {
    name:"cometchat-chat-sample-app-react",
    version:"4.3.3",
    type:"sample",
    platform:"React"
}